import { MouseEvent } from 'react';

export default (event: MouseEvent) => {
  return event.ctrlKey || event.metaKey || event.button === 1;
};
